<template>
    <div
        class="flex flex-row gap-2 items-center"
        :class="$attrs.class"
    >
        <span
            class="text-gray-500 text-right cursor-pointer"
            :class="{['text-'+this.size]: true}"
            v-if="labelLeft"
            v-html="labelLeft"
            @click="change(false)"
            ref="left-label"
        />
        <div
            class="flex items-center rounded-full bg-gray-400 cursor-pointer"
            :class="{
                'bg-gray-400': !modelValue,
                'bg-green-400': !!modelValue,
                'justify-end':  !!modelValue,
            }"
            :style="sizes[size].out"
            @click="change(null)"
        >
            <div
                class="bg-white rounded-full shadow-md transform"
                :style="sizes[size].in"
            ></div>
        </div>
        <span
            class="text-gray-500 cursor-pointer"
            :class="{['text-'+this.size]: true}"
            v-html="label"
            v-if="label"
            @click="change(label&&labelLeft ? true : null)"
            ref="right-label"
        />
        <input-error :message="error"/>
    </div>
</template>

<script>
import InputError from "@/Components/InputError.vue";

export default {
    inheritAttrs: false,
    components: {
        InputError,
    },
    props: {
        label: {
            type: String,
            default: null,
        },
        labelLeft: {
            type: String,
            default: null,
        },
        modelValue: Boolean,
        size: {
            type: String,
            default: 'base',
        },
        error: String,
    },
    data () {
        return {
            sizes: {
                xs: {
                    out: { width: '2.4rem', height: '1.2rem', 'padding-left': '0.2rem', 'padding-right': '0.2rem' },
                    in: { width: '0.8rem', height: '0.8rem' },
                },
                sm: {
                    out: { width: '2.8rem', height: '1.4rem', 'padding-left': '0.2rem', 'padding-right': '0.2rem' },
                    in: { width: '1rem', height: '1rem' },},
                base: {
                    out: { width: '3.5rem', height: '1.75rem', 'padding-left': '0.25rem', 'padding-right': '0.25rem' },
                    in: { width: '1.25rem', height: '1.25rem' },
                },
                lg: {
                    out: { width: '4.2rem', height: '2.1rem', 'padding-left': '0.3rem', 'padding-right': '0.3rem' },
                    in: { width: '1.5rem', height: '1.5rem' },
                },
                xl: {
                    out: { width: '5.15rem', height: '2.575rem', 'padding-left': '0.35rem', 'padding-right': '0.35rem' },
                    in: { width: '1.875rem', height: '1.875rem' },
                },
            }
        }
    },
    methods: {
        change(t = null) {
            this.$emit('update:modelValue', (t !== null) ? t : !this.modelValue);
            this.$emit('change', true);
        },
    },
    mounted () {
        if(!this.label || !this.labelLeft) return;

        const right = this.$refs['right-label'].offsetWidth,
            left = this.$refs['left-label'].offsetWidth;
        if(right && left && right !== left) {
            if(right > left) this.$refs['left-label'].style.width = `${right}px`;
            else this.$refs['right-label'].style.width = `${left}px`;
        }
    },
}
</script>
